<div id="div2" style="display:block"  class="soaclass">
    <br><br>
    <p align="center" style="font-size:x-large;">
  <b> <span id="lblMsg" style="font-weight:bold;">Thank you, the information has been submitted.</span> </b>
   </p>
   <br>
  